import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../ui/common.css";
import "../Styles/style.css";
import "../Styles/blog-detail.css";
import config from "../config";

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(
      `${config.API_BASE_URL}/contentinner/${id}`
      //`/prosapiens-cms/public/api/contentinner/${id}`
    )
      .then((res) => res.json())
      .then((data) => {
        setBlog(data.content || null);
        console.log(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching blog details:", err);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p className="container">Loading blog...</p>;
  if (!blog) return <p className="container">Blog not found.</p>;

  return (
    <>
      {/* Hero Banner */}
      <section className="blog-detail-hero">
        <div className="container">
          <h1 className="blog-detail-title">{blog.content_inner_title}</h1>
          <div className="blog-detail-meta">
            <span>by {blog.content_inner_by || "Admin"}</span>
            <span> | </span>
            <span>{blog.created_inner_at}</span>
            <span> | </span>
            <span>{blog.category || "General"}</span>
            <span> | </span>
            <span>{blog.comment_inner_count || 0} comments</span>
          </div>
          {blog.content_inner_image && (
            <div className="blog-detail-featured">
              <img
                src={`/prosapiens-cms/public/${blog.content_inner_image}`}
                alt={blog.content_inner_title}
              />
            </div>
          )}
        </div>
      </section>

      {/* Blog Content */}
      <section className="container blog-detail-layout">
        <article className="blog-detail-content">
          <div dangerouslySetInnerHTML={{ __html: blog.content_inner_text }} />
        </article>

        {/* Sidebar (Optional) */}
        <aside className="blog-detail-sidebar">
          <div className="widget">
            <h4>Recent Posts</h4>
            <ul className="recent-posts">
              {/* You can later fetch recent blogs here too */}
              <li>
                <a href="/blogs/1">Sample Blog</a>
              </li>
            </ul>
          </div>
        </aside>
      </section>
    </>
  );
};

export default BlogDetail;
